import { setUser as setSentryUser } from '@sentry/react';
import { queryClient } from '../query-client';
import { removeEmulationHeaders } from './emulate';

export function clearUsersData() {
  setSentryUser(null);
  removeEmulationHeaders();
  queryClient.clear();
}
